module.exports = __webpack_public_path__ + "img/hr-assembling-machine-2-pipe-W.47d755c2.png";